import http from './http.service';

class BookingLockedDateService {
    constructor() {
        if (BookingLockedDateService.instance) {
            return BookingLockedDateService.instance;
        }

        BookingLockedDateService.instance = this;
    }

    dates() {
        return http.get('/booking-locked-date').then(res => res.data);
    }
    store(data) {
        return http.post('/booking-locked-date/store', data).then(res => res.data);
    }
    update(dateId, data) {
        return http.put(`/booking-locked-date/${dateId}/update`, data).then(res => res.data);
    }
    destroy(dateId) {
        return http.delete(`/booking-locked-date/${dateId}/destroy`).then(res => res.data);
    }
}

export default new BookingLockedDateService();
